export const RoleEnum = {
  org_admin: 'org_admin',
  surgical_chair: 'surgical_chair',
  surgeon: 'surgeon',
  superadmin: 'superadmin',
} as const;

export type RoleEnumType = keyof typeof RoleEnum;

export const userRoleList: Record<string, { label: string; value: string }> = {
  [RoleEnum.org_admin]: {
    label: 'Admin',
    value: 'org_admin',
  },
  [RoleEnum.surgical_chair]: {
    label: 'Surgical Chair',
    value: 'surgical_chair',
  },
  [RoleEnum.surgeon]: {
    label: 'Surgeon',
    value: 'surgeon',
  },
  [RoleEnum.superadmin]: {
    label: 'Super Admin',
    value: 'superadmin',
  },
};
